$('#Config_recaptchaType').on('change mount', function () {
    const type = this.value;
    const $v3Set = $(`#Config_recaptchaKey`).closest('.form-set');
    const $enterpriseSet = $(`#Config_recaptchaEnterprisePublicKey`).closest('.form-set');
    const $captcha4ocSet = $(`#Config_captcha4ocKey`).closest('.form-set');
    const $turnstileSet = $(`#Config_turnstileKey`).closest('.form-set');
    $v3Set.toggleClass('d-none', type != 'v3');
    $enterpriseSet.toggleClass('d-none', type != 'enterprise');
    $captcha4ocSet.toggleClass('d-none', type != 'captcha4oc');
    $turnstileSet.toggleClass('d-none', type != 'turnstile');
}).trigger('mount');

$('.promotional-products').each(function () {
    const $container = $(this);
    const $fetchBtn = $container.find('[data-ref="fetch-btn"]');
    const $collection = $container.find('[data-ref="collection"]');
    const $addBtn = $container.find('.field-collection-add-button');
    const deleteBtnClass = '.field-collection-delete-button';

    $addBtn.hide();
    $collection.find(deleteBtnClass).hide();
    
    $fetchBtn.on('click', async function () {
        $fetchBtn.prop('disabled', true);
        try {
            const url = $fetchBtn.data('url');
            const response = await fetch(url);
            const products = await response.json();

            $collection.find(deleteBtnClass).trigger('click');
            products.forEach((product) => {
                $addBtn.trigger('click');
                $collection.find('input[type="text"]').last().val(product);
                
            });
            $collection.find(deleteBtnClass).hide();
        } catch (error) {
            console.error(error);
            alert('Wystąpił błąd podczas pobierania produktów promocyjnych.');
        } finally {
            $fetchBtn.prop('disabled', false);
        }
    });
});

$('.receipt-stores').each(function () {
    const $container = $(this);
    const $fetchBtn = $container.find('[data-ref="fetch-btn"]');
    const $collection = $container.find('[data-ref="collection"]');
    const $addBtn = $container.find('.field-collection-add-button');
    const deleteBtnClass = '.field-collection-delete-button';

    $addBtn.hide();
    $collection.find(deleteBtnClass).hide();
    
    $fetchBtn.on('click', async function () {
        $fetchBtn.prop('disabled', true);
        try {
            const url = $fetchBtn.data('url');
            const response = await fetch(url);
            const products = await response.json();

            $collection.find(deleteBtnClass).trigger('click');
            products.forEach((product) => {
                $addBtn.trigger('click');
                $collection.find('input[type="text"]').last().val(product);
                
            });
            $collection.find(deleteBtnClass).hide();
        } catch (error) {
            console.error(error);
            alert('Wystąpił błąd podczas pobierania sklepów.');
        } finally {
            $fetchBtn.prop('disabled', false);
        }
    });
});